module.exports = __webpack_public_path__ + "0d19b8ce8c65d89e69fd3278bbdbcc3d.png";